<template>
  <div class="login">
    <div class="left">
      <img :src="loginTip" />
      <el-button class="btn" @click="backHome">
        <el-icon color="#ffffff"><ArrowLeft /></el-icon>
        返回首页</el-button
      >
    </div>
    <div class="right">
      <div class="login-welcome">欢迎登录！</div>
      <div class="form-info">
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="120px"
          label-position="top"
          size="large"
        >
          <el-form-item label="手机号码" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入手机号码"
              maxlength="11"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <div class="code-box">
              <el-input v-model="form.code" placeholder="请输入验证码" />
              <el-button
                class="code-btn"
                :disabled="isCountingDown || !canGetCode"
                @click="getVerificationCode"
              >
                {{ countdown > 0 ? `${countdown}秒后重新获取` : "获取验证码" }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="save-box">
        <el-button class="btn" type="primary" @click="loginHandle(formRef)"
          >立即登录</el-button
        >
      </div>
      <div class="agreement">
        <el-checkbox v-model="userAgree" size="large"
          >同意
          <a
            href="https://kejiribao.testnewmedia.xinhuaapp.com/html/user_agreement_xcx.html
          "
            target="_blank"
            >《科技日报》用户协议</a
          ></el-checkbox
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { watch, ref, reactive, h } from "vue";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import api from "@/services/index";
import { siteId } from "@/services/config";
import loginTip from "@/assets/login_tip.png";
import { useRouter, useRoute } from "vue-router";
import routerTree from "@/router/config";
import userInfoStore from "@/store/index";

const userStore = userInfoStore();
const formRef = ref();
const router = useRouter();
const countdown = ref(0);
const userAgree = ref(false);
const isCountingDown = ref(false);
let timer: any = null;

const form = reactive({
  phone: "",
  code: "",
});
const validatePhone = async (_, value: string) => {
  const phoneReg = /^1[3-9]\d{9}$/;
  if (!value) {
    throw new Error("请输入手机号码");
  }
  if (!phoneReg.test(value)) {
    throw new Error("手机号格式不正确");
  }
};
const rules = reactive({
  phone: [
    { required: true, message: "请输入手机号码", trigger: "blur" },
    { validator: validatePhone, trigger: "blur" },
  ],
  code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
});

// 检查手机号是否有效，这里简单判断长度
const canGetCode = ref(false);

watch(
  () => form.phone,
  () => {
    // 监听手机号变化
    console.log("监听手机号变化");
    canGetCode.value = form.phone.length === 11;
  }
);

// 获取验证码
const getVerificationCode = async () => {
  if (!form.phone) {
    ElMessage.warning("请输入手机号码");
    return;
  }
  if (!/^1[3-9]\d{9}$/.test(form.phone)) {
    ElMessage.warning("请输入正确的手机号码");
    return;
  }
  const params = {
    phone: form.phone,
    siteId,
  };
  const res = await api.login.sendCode(params);
  if (res.status == 200) {
    ElMessage({
      message: "发送验证码成功 ",
      type: "success",
    });
    // 开始倒计时
    isCountingDown.value = true;
    countdown.value = 60;
    timer = setInterval(() => {
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(timer);
        isCountingDown.value = false;
      }
    }, 1000);
    return;
  }
  ElMessage({
    message: "发送验证码失败 ",
    type: "error",
  });
};

//返回主页
const backHome = () => {
  //router.push(routerTree.home);
  window.location.href = "https://www.stdaily.com";
};
//获取用户个人信息
const getUserInfo = async () => {
  try {
    const res = await api.login.getUserInfo({});
    if (res.status == 200) {
      localStorage.setItem("userInfo", JSON.stringify(res.obj));
      userStore.isLogin = true;
      userStore.userInfo = res.obj;
    }
  } catch (err) {
    console.log("err", err);
  }
};
//登录
const loginHandle = async (formRef: FormInstance) => {
  if (userAgree.value == false) {
    ElMessage({
      message: "请先勾选《科技日报》用户协议！",
      type: "warning",
    });
    return;
  }
  if (!formRef) return;
  formRef.validate(async (valid) => {
    if (valid) {
      const params = {
        phone: form.phone,
        code: form.code,
        siteId,
      };
      const res = await api.login.phoneLogin(params);
      if (res.status == 200) {
        //将token存在本地
        localStorage.setItem("token", res.obj.accessToken);

        ElMessage({
          message: res.msg,
          type: "success",
        });
        getUserInfo();
        setTimeout(() => {
          router.push(routerTree.home);
        }, 1000);

        return;
      }
      ElMessage({
        message: res.msg,
        type: "error",
      });
    }
  });
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - 4.9rem);
  background: url("@/assets/login_back.png") no-repeat;
  background-size: cover;
  background-position: center;
  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: center;
    width: 42rem;
    height: 42rem;
    img {
      width: 40rem;
      height: 14rem;
    }
    .btn {
      display: flex;
      align-items: center;
      width: 10rem;
      height: 3.2rem;
      border-radius: 0.8rem;
      border: 0.1rem solid #75b2ef;
      opacity: 0.8;
      font-size: 1.4rem;
      color: #ffffff;
      background: #75b2ef;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4rem 6rem;
    width: 42rem;
    height: 47rem;
    background: #ffffff;
    border-radius: 0.8rem;
    margin-left: 12rem;
    .login-welcome {
      width: 100%;
      height: 6.6rem;
      line-height: 8.6rem;
      font-size: 2.6rem;
      font-weight: 600;
    }
    .form-info {
      width: 100%;
      height: auto;
      .el-form-item {
        text-align: left;
        margin-top: 3rem;
      }
      .code-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 4.5rem;
        line-height: 4.5rem;
        .code-btn {
          display: flex;
          align-items: center;
          width: 14.8rem;
          height: 3.8rem;
          line-height: 3.8rem;
          margin-top: 1rem;
          margin-left: 0.4rem;
          border-radius: 0.8rem;
          font-size: 1.3rem;
          border: none;
          background: #d0e5f7;
          color: #348dfb;
        }
      }
      :deep(.el-form-item__label) {
        font-size: 1.4rem;
        font-weight: 600;
        color: #000000;
      }
      :deep(.el-input__wrapper) {
        width: 100%;
        height: 3.6rem;
        margin-top: 1rem;
        border-radius: 0.8rem;
      }
      :deep(.el-input__inner) {
        width: 100%;
        height: 3.6rem;
        font-size: 1.4rem;
      }
      :deep(.el-input__count-inner),
      :deep(.el-form-item__error) {
        font-size: 1.4rem;
      }
    }
    .save-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 3.6rem;
      margin-top: 3rem;
      .btn {
        width: 30rem;
        height: 4.4rem;
        line-height: 4.4rem;
        border-radius: 0.8rem;
        font-size: 1.4rem;
        background: #0050f3;
      }
    }
    .agreement {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 19.8rem;
      height: 2rem;
      margin-top: 2.5rem;
      a {
        color: #348dfb;
      }
      :deep(.el-checkbox__label) {
        font-size: 1.4rem;
      }
      :deep(.el-checkbox__inner) {
        width: 1.6rem;
        height: 1.6rem;
      }
      :deep(.el-checkbox__inner:after) {
        left: 0.5rem;
        top: 0.25rem;
        width: 0.22rem;
        height: 0.5rem;
      }
    }
  }
}
</style>